module.exports = __webpack_public_path__ + "img/25.a21b4590.png";